/* eslint-disable dot-notation */
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

import Switcher from '../Switcher/Switcher';

import MapIcon from './MapIcon';
import SquareListIcon from './SquareListIcon';

const MapListSwitcher = ({ onClickLeft, onClickRight, isPositionRight }) => (
  <Switcher
    onClickLeft={onClickLeft}
    onClickRight={onClickRight}
    isPositionRight={isPositionRight}
    renderLeftIcon={() => <SquareListIcon color={Colors.interaction} />}
    renderRightIcon={() => <MapIcon color={Colors.interaction} />}
    dataTest="map-list-switcher"
  />
);

MapListSwitcher.propTypes = {
  onClickLeft: PropTypes.func.isRequired,
  onClickRight: PropTypes.func.isRequired,
  isPositionRight: PropTypes.bool.isRequired
};

export default MapListSwitcher;
